import React, { Component } from "react";
import Helmet from 'react-helmet';
import firebase from "firebase";
import "firebase/auth";
import Layout from '../components/layout';
import Loading from '../components/Loading';
import NotFoundPage from './404';
import NotAuthorized from '../components/NotAuthorized';
import Map from '../components/maps/Map';
import UserDataService from "../services/UserDataService";
import ProfileUser from "../components/ProfileUser";
import { Remarkable } from 'remarkable';
import RemarkableReactRenderer from 'remarkable-react';
import axios from "axios";
import { translate } from "react-i18next"
import i18n from '../components/lang/i18n'

const socialSwitcher = 2;

class Profile extends Component {
  constructor(props) {
    super(props);
    this.i18n = i18n;
    this.profileRef = React.createRef();
    this.showMessage = this.showMessage.bind(this);
    this.setAuthUserId = this.setAuthUserId.bind(this);
    this.onDataChange = this.onDataChange.bind(this);
    this.handler = this.handler.bind(this)

    this.state = {
      currentUser: {
        userId: null,
        prename: "", 
        surname: "", 
        mail: "",
        showMail: false,
        company: "", 
        jobtitle: "",
        category: "", 
        street: "", 
        number: "", 
        zipcode: "", 
        city: "", 
        country: "", 
        showAddress: false,
        phone: "", 
        showPhone: false,
        website: "",
        citation: "",
        description: "",
        cover: "",
        pic1: "",
        facebook: "",
        instagram: "",
        pinterest: "",
        twitter: "",
        xing: "",
        linkedin: "",
        position: false,
        isActive: false,
      },
      message: "",
      editProfile: false,
      authUserId: null,
      isLoading: true,
      notAuthed: true,
      notFound: false,
      isProfile: false,
      showEditButton: true,
      isApp: false,
    };
  }

  handler() {
    this.setState({
      isApp: false,
    })
  }

  showMessage(message) {
    this.setState({
        message: message,
    });
  }

  setAuthUserId(id) {
    this.setState({
      authUserId: id,
    });
  }

  initFirebase() {
    firebase.auth().onIdTokenChanged(function(user) {
      this.setState({
        isProfile: true,
      });
      if (user) {
        // User is signed
        var id = firebase.auth().currentUser.uid;
        this.setAuthUserId(id);
        UserDataService.getUser(id).on("value", this.onDataChange);
        this.setState({
          notAuthed: false,
        });
      } else {
        UserDataService.getUser("no").on("value", this.onDataChange);
      }
    }.bind(this));
  }

  componentDidMount() {
    if (this.props.location.pathname.split('/')[2]) {
      UserDataService.getUser(this.props.location.pathname.split('/')[2]).on("value", this.onDataChange);
    } else {
      this.initFirebase();
    }
  }

  onDataChange(item) {
    if (item.val() !== null) {
      var data = item.val()
      this.setState({
        //currentUser: item.val(),
        currentUser: {
          userId: data.userId,
          objectID: data.userId,
          prename: data.prename || "",
          surname: data.surname || "",
          mail: data.mail || "",
          showMail: data.showMail || false,
          company: data.company || "",
          jobtitle: data.jobtitle || "",
          category: data.category || "",
          street: data.street || "",
          number: data.number || "",
          zipcode: data.zipcode || "",
          city: data.city || "",
          country: data.country || "", 
          showAddress: data.showAddress || false,
          phone: data.phone || "",
          showPhone: data.showPhone || false,
          website: data.website || "",
          citation: data.citation || "",
          description: data.description || "",
          cover: data.cover || "",
          pic1: data.pic1 || "",
          facebook: data.facebook || "",
          instagram: data.instagram || "",
          pinterest: data.pinterest || "",
          twitter: data.twitter || "",
          xing: data.xing || "",
          linkedin: data.linkedin || "",
          position: data.position || false,
          isActive: data.isActive || false,
        },
        isLoading: true,
      });
    } else {
      this.setState({
        isLoading: false,
        notFound: true,
      });
    }
  }

  setStateFromChild = (childData) => {
    //this.setState({currentUser: childData})
    //console.log(childData)
  }

  changeEditButton = (childData) => {
      this.setState({
        showEditButton: childData
      });
  }

  onClick = () => {
    this.setState({
      showEditButton: false,
    }, () => this.profileRef.current.editProfile(true, this.state.currentUser, this.state.authUserId));
  };

  abuseClick = () => {
    var mail = prompt(i18n.t("profile_abuse_prompt", "Bitte gib deine Mail-Adresse ein:"), "");
    if (mail) {
      var message = "Das Profil von " + this.state.currentUser.mail + " wurde gemeldet!"

      axios({
        url: 'https://formspree.io/f/xbjqlrzg',
        method: 'post',
        headers: {
          'Accept': 'application/json'
        },
        data: {
          email: mail,
          message: message
        }
      })
      .then((response) => { 
        console.log(response); 
        this.showMessage(i18n.t("profile_abuse_success", "Das Profil wurde gemeldet."));
      })
      .catch((error) => {
        this.showMessage(i18n.t("profile_abuse_error", "Bitte überprüfe deine eingegebene Mail-Adresse und versuche es erneut."))
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
      })
    }
  }

  render() {
    const { t } = this.props
    
    var md = new Remarkable();
    md.renderer = new RemarkableReactRenderer();
    var html = md.render(this.state.currentUser.description);

    if (this.state.currentUser.userId) {
      firebase.analytics().logEvent('select_content', {
        content_type: this.state.currentUser.mail,
        item_id: this.state.currentUser.userId,
      });
    }

    var socialLinks = 0
    if (this.state.currentUser.facebook) socialLinks++;
    if (this.state.currentUser.instagram) socialLinks++;
    if (this.state.currentUser.pinterest) socialLinks++;
    if (this.state.currentUser.twitter) socialLinks++;
    if (this.state.currentUser.linkedin) socialLinks++;
    if (this.state.currentUser.xing) socialLinks++;
    //console.log(socialLinks);

    return (
      <div>
      {this.state.currentUser.userId ? (
            <Layout cl="" handler={this.handler}>
            <Helmet>
                <title>WFOW - {this.state.currentUser.prename} {this.state.currentUser.surname}</title>
                <meta name="description" content={this.state.currentUser.citation} />
            </Helmet>

            <div id="main">
                        {/* Banner */}
                        <section id="banner" style={{ backgroundImage: `url(${this.state.currentUser.cover})` }}>
                            <div className="inner">
                                <header className="major">
                                    <h1>{this.state.currentUser.prename} {this.state.currentUser.surname}</h1>
                                </header>
                                    <h3>{this.state.currentUser.company} | {this.state.currentUser.jobtitle ? (<>{this.state.currentUser.jobtitle} | </>) : (<></>)}{this.state.currentUser.category}</h3>
                                <div className="content">
                                    <blockquote>{this.state.currentUser.citation}</blockquote>
                                </div>
                            </div>
                        </section>

                        {/* Pic & Description */}
                        <section id="one" className="cards-top cards-bottom">
                            <div className="inner">
                                      <div className="grid-wrapper">
                                        <div className="col-3">
                                            {this.state.currentUser.pic1 ? (
                                            <span className="image fit"><img className="profilepic" src={this.state.currentUser.pic1} alt="Profilbild"/></span>
                                            ) : (
                                                <span></span>
                                            )}
                                            <br/>
                                        </div>
                                        <div className="col-9">
                                        {html ? (
                                        <div>
{/*                                         <header className="major">
                                            <h3>Über mich</h3>
                                        </header> */}
                                        <div className="description">
                                          {html}
                                        </div>
                                        </div>
                                        ) : (<span></span>)}
                                        </div>
                                      </div>
                                  </div>
                        </section>

                        {/* Contact */}
                        {this.state.currentUser.showAddress || this.state.currentUser.showPhone || this.state.currentUser.showMail || this.state.currentUser.website ? (
                          <section id="two" className="spotlights cards-bg-white">
                            <div className="inner">
                                <header className="major">
                                    <h3>{t("profile_contact", "Du möchtest mich kontaktieren?")}</h3>
                                </header>
                                {/* Address */}
                                {this.state.currentUser.showAddress ? (
                                  <ul className="alt">
                                      <li>{this.state.currentUser.company}</li>
                                      <li>{this.state.currentUser.street} {this.state.currentUser.number}</li>
                                      <li>{this.state.currentUser.zipcode} {this.state.currentUser.city}</li>
                                      <li>{this.state.currentUser.country}</li>
                                  </ul>) : (<span></span>)}

                                {/* Web, Mail, Phone */}
                                <ul className="actions vertical">

                                    {this.state.currentUser.website ? (
                                    <li><span className="icon fa-desktop"><a href={this.state.currentUser.website} target="_blank" rel="noreferrer" aria-label="Website" className="profile-link">{this.state.currentUser.website}</a></span></li>
                                    ) : (<span></span>)}

                                    {this.state.currentUser.phone && this.state.currentUser.showPhone ? (
                                    <li><span className="icon fa-phone"><a href={"callto:"+this.state.currentUser.phone} aria-label="Phone" className="profile-link">{this.state.currentUser.phone}</a></span></li>
                                    ) : (<span></span>)}

                                    {this.state.currentUser.mail && this.state.currentUser.showMail ? (
                                    <li><span className="icon fa-envelope"><a href={"mailto:"+this.state.currentUser.mail} aria-label="Mail" className="profile-link">{this.state.currentUser.mail}</a></span></li>
                                    ) : (<span></span>)}

                                    {socialLinks <= socialSwitcher ? (
                                    <>
                                    {this.state.currentUser.facebook ? (
                                    <li><span className="icon fa-facebook"><a href={this.state.currentUser.facebook} aria-label="Facebook" className="profile-link">{this.state.currentUser.prename} {t("profile_on", "auf")} Facebook</a></span></li>
                                    ) : (<span></span>)}

                                    {this.state.currentUser.instagram ? (
                                    <li><span className="icon fa-instagram"><a href={this.state.currentUser.instagram} aria-label="instagram" className="profile-link">{this.state.currentUser.prename} {t("profile_on", "auf")} Instagram</a></span></li>
                                    ) : (<span></span>)}

                                    {this.state.currentUser.pinterest ? (
                                    <li><span className="icon fa-pinterest"><a href={this.state.currentUser.pinterest} aria-label="pinterest" className="profile-link">{this.state.currentUser.prename} {t("profile_on", "auf")} Pinterest</a></span></li>
                                    ) : (<span></span>)}

                                    {this.state.currentUser.twitter ? (
                                    <li><span className="icon fa-twitter"><a href={this.state.currentUser.twitter} aria-label="Twitter" className="profile-link">{this.state.currentUser.prename} {t("profile_on", "auf")} Twitter</a></span></li>
                                    ) : (<span></span>)}

                                    {this.state.currentUser.xing ? (
                                    <li><span className="icon fa-xing"><a href={this.state.currentUser.xing} aria-label="Xing" className="profile-link">{this.state.currentUser.prename} {t("profile_on", "auf")} Xing</a></span></li>
                                    ) : (<span></span>)}

                                    {this.state.currentUser.linkedin? (
                                    <li><span className="icon fa-linkedin"><a href={this.state.currentUser.linkedin} aria-label="LinkedIn" className="profile-link">{this.state.currentUser.prename} {t("profile_on", "auf")} LinkedIn</a></span></li>
                                    ) : (<span></span>)}
                                    </>
                                    ) : (<span></span>)}

                                </ul>
                            </div>
                          </section>
                        ): (<span></span>)}

                        {this.state.currentUser.showAddress ? (
                        <div id="container" className="cards-bottom">
                            <Map user={this.state.currentUser}/>
                        </div>
                        ) : (<span></span>)}

                        {/* Social Media */}
                        {socialLinks > socialSwitcher ? (
                        <>
                          {this.state.currentUser.facebook || this.state.currentUser.instagram || this.state.currentUser.twitter || this.state.currentUser.xing|| this.state.currentUser.linkedin   ? (
                              <section id="three" className="">
                                <div className="inner">
                                    <header className="major">
                                        <h3>{t("profile_social", "Du findest mich auch auf:")}</h3>
                                    </header>
                                        <ul className="icons">
                                            {this.state.currentUser.facebook ? (
                                            <li>
                                            <a href={this.state.currentUser.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="icon fa-facebook fa-2x">
                                                <span className="label">Facebook</span>
                                            </a>
                                            </li>
                                            ) : (<span></span>)}
                                            {this.state.currentUser.instagram ? (
                                            <li>
                                            <a href={this.state.currentUser.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="icon fa-instagram fa-2x">
                                                <span className="label">Instagram</span>
                                            </a>
                                            </li>
                                            ) : (<span></span>)}
                                            {this.state.currentUser.pinterest ? (
                                            <li>
                                            <a href={this.state.currentUser.pinterest} target="_blank" rel="noreferrer" aria-label="Pinterest" className="icon fa-pinterest fa-2x">
                                                <span className="label">Pinterest</span>
                                            </a>
                                            </li>
                                            ) : (<span></span>)}
                                            {this.state.currentUser.twitter ? (
                                            <li>
                                            <a href={this.state.currentUser.twitter} target="_blank" rel="noreferrer" aria-label="Twitter" className="icon fa-twitter fa-2x">
                                                <span className="label">Twitter</span>
                                            </a>
                                            </li>
                                            ) : (<span></span>)}
                                            {this.state.currentUser.xing ? (
                                            <li>
                                            <a href={this.state.currentUser.xing} target="_blank" rel="noreferrer" aria-label="Xing" className="icon fa-xing fa-2x">
                                                <span className="label">XING</span>
                                            </a>
                                            </li>
                                            ) : (<span></span>)}
                                            {this.state.currentUser.linkedin ? (
                                            <li>
                                            <a href={this.state.currentUser.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="icon fa-linkedin fa-2x">
                                                <span className="label">LinkedIn</span>
                                            </a>
                                            </li>
                                            ) : (<span></span>)}
                                        </ul>
                                    </div>
                                  </section>
                              ) : (<span></span>)}
                              </>) : (<></>)}

                            <section id="four" className="profile-abuse-div">
                                <div className="align-right cards-bg-inherit"><a className="abuse-link profile-link" onClick={this.abuseClick}>{t("profile_abuse", "Profil melden?")}</a><span className="center"> {this.state.message}</span></div>  
                            </section>

                            {this.state.authUserId ? (
                            <section id="five" className="cards-top">
                                <div className="inner">
                                  {this.state.showEditButton === true ? (
                                    <ul className="actions fit small">
                                        <li><a className="button special fit small" onClick={this.onClick}>{t("profile_edit", "Profil bearbeiten")}</a></li>
                                    </ul>
                                    ) : (<span></span>)}
                                    <ProfileUser user={this.state.currentUser} ref={this.profileRef} parentCallback={this.setStateFromChild} changeEditButton={this.changeEditButton}/>
                                </div>
                            </section>
                            ) : (
                              <span></span>
                            )}
                    </div>
        </Layout>

        ) : (
          <div>
            {this.state.isLoading ? (
              <div><Loading /></div>
              ) : (
            <div>
            {this.state.notFound && !this.state.isProfile ? (<NotFoundPage/>) : (<div></div>)}
            {this.state.notFound && this.state.notAuthed && this.state.isProfile ? (<Layout cl="" handler={this.handler}><NotAuthorized isApp={this.state.isApp}/></Layout>):(<div></div>)}
            </div>)}
        </div>
        )}
        </div>
        )
    }
} 

export default translate("Index")(Profile)